import Modal from "../../../common/components/Modal.jsx"
import Textarea from "../../../common/components/Textareafield.jsx"
import FileUploader from "../../../common/components/FileUploader.jsx"
import Button from "../../../common/components/Button.jsx"
import Select from "../../../common/components/Select.jsx"
import { TYPES_DOCUMENTS } from "../constants/constants.js"

function ModalVariousDocumentAdmin({ isOpen, onClose, document, onSubmit, errors, onChange, loading }) {

  const handleSubmit = (e) => {
    e.preventDefault()
    onSubmit()
  }

  return (
    <Modal isOpen={isOpen} onClose={onClose}>
      <div className="p-4">

        <h1 className="h4">Documento</h1>

        <form onSubmit={handleSubmit}>
          <Select label="Descripcion" value={document?.description} onChange={onChange} name="description" error={errors?.description} options={TYPES_DOCUMENTS} />
          <FileUploader label="Archivo" value={document?.file} onFileChange={(file) => onChange({ name: "file", value: file })} name="file" error={errors?.file} />
          <Textarea label="Observaciones" placeholder="Escribe las observaciones aqui..." value={document?.observations} onChange={onChange} name="observations" />
          <Button type="submit" loading={loading} disabled={loading}>Guardar</Button>
        </form>

      </div>
    </Modal>
  )
}

export default ModalVariousDocumentAdmin;
